import React from "react";
import Header from "./Header";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Footer from "./Footer";
import CreateNote from "./CreateNote";
import Note from "./Note";
import { useState } from "react";
import { useEffect } from "react";

const App = () => {

  const [addItem, setAddItem] = useState([]);

  const addNote = (note) =>{
    // alert("I am clicked");
    setAddItem((prevData)=>{
      localStorage.setItem("note", JSON.stringify([...prevData, note]));
      return [...prevData, note];
    });
    
  };

  const onDelete=(id) =>{
    setAddItem((olddata) => {
    const resArr = olddata.filter((currdata, indx) =>{
      return indx !==id ;
    });
    localStorage.setItem("note", JSON.stringify(resArr));
    return resArr;
  });
  };

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("note"));
    if(data ===null){
      return setAddItem([]);
    }
    setAddItem(data);
  }, []);

  return(
  <>
    <Header/>
    <CreateNote
      passNote={addNote} />

    {addItem.map((val, index)=>{
      return (<Note 
        key={index}
        id={index}
        title={val.title}
        content={val.content}
        deleteItem = {onDelete}
      />
      );
    })}

    <Footer />
  </>
  );
};

export default App;

// import React from "react";
// import { Route, Routes, Navigate } from "react-router-dom";
// import About from "./About";

// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'



